import { render, staticRenderFns } from "./RecruitmentViewPage.vue?vue&type=template&id=4af4b3fe"
import script from "./RecruitmentViewPage.vue?vue&type=script&lang=js"
export * from "./RecruitmentViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports